(function($) {
    if (typeof Drupal !== "undefined") {
        Drupal.behaviors.custom_theme_file = {
            attach: function(context, settings) {
                init();
            }
        };
    } else {
        init();
    }

    function init() {

        // ДОБАВЛЯЕМ ОБЕРТКУ SPAN В ТАБЛИЦУ В ПЕРВУЮ ЯЧЕЙКУ
        $(".teaser-node-unit-catalog table tr").each(function () {
            $(this).find("td").wrapInner("<span></span>");
        });
        // КОНЕЦ

    }

    $(document).ready(function(){

        jQuery(".kint-parent").on('click', function(){
            jQuery(this).next().toggle();
        });

        $("table").each(function(){
            if ( !$(this).parents(".dev-modal").length && ( $(this).width() > $(this).parent().width() ) ) {
                var marginBottom = $(this).css("margin-bottom");
                $(this).wrap("<div class=\"table-wrapper\" style=\"margin-bottom: " + marginBottom + "\"></div>");
                $(this).css({"margin-bottom":"0"});
                if ( !$(this).hasClass("nostyle") ) {
                    $(this).addClass("table-no-hover");
                }
            }
        });
        if ( $(".table-wrapper").length ) {
            $(".table-wrapper").mCustomScrollbar({
                alwaysShowScrollbar: 0,
                axis: "x",
                scrollbarPosition: "outside"
            });
        }
        if ( $(".lightgallery").length ) {
            lightGallery(".lightgallery", "this");
            lightGallery(".photo_gallery","a");
        }
    });

})(jQuery);
